import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { ScrollArea } from '../ui/scroll-area';

export function Layout({ children, title = 'Dashboard' }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header 
          onMenuClick={() => setSidebarOpen(true)} 
          title={title}
        />
        
        <ScrollArea className="flex-1">
          <main className="p-4 lg:p-6 max-w-[1600px] mx-auto">
            {children}
          </main>
        </ScrollArea>
      </div>
    </div>
  );
}
